/**
 * Feature flags — single source of truth for toggling whole product areas.
 *
 * v1 marketplace pivot: the Property Manager (PM) side is hidden behind
 * `propertyManager` (default OFF). All PM code remains in the tree; only its
 * routes, navigation and signup entry points are gated. Flip the env var to
 * fully restore it — no code is deleted.
 *
 *   VITE_ENABLE_PM=true   → PM visible (legacy behaviour)
 *   (unset / anything else) → PM hidden (customer + technician only)
 */
export const FEATURES = {
  propertyManager: import.meta.env.VITE_ENABLE_PM === "true",
} as const;

export type FeatureName = keyof typeof FEATURES;
